import React from "react";

export const CopyOutlineIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6500_6352)">
      <path
        d="M4.16797 12.5C3.3914 12.5 3.00311 12.5 2.69683 12.3731C2.28845 12.2039 1.96399 11.8795 1.79484 11.4711C1.66797 11.1648 1.66797 10.7765 1.66797 9.99996V4.33329C1.66797 3.39987 1.66797 2.93316 1.84962 2.57664C2.00941 2.26304 2.26438 2.00807 2.57798 1.84828C2.9345 1.66663 3.40121 1.66663 4.33464 1.66663H10.0013C10.7779 1.66663 11.1662 1.66663 11.4724 1.79349C11.8808 1.96265 12.2053 2.28711 12.3744 2.69549C12.5013 3.00177 12.5013 3.39006 12.5013 4.16663M10.168 18.3333H15.668C16.6014 18.3333 17.0681 18.3333 17.4246 18.1516C17.7382 17.9918 17.9932 17.7369 18.153 17.4233C18.3346 17.0668 18.3346 16.6 18.3346 15.6666V10.1666C18.3346 9.23321 18.3346 8.7665 18.153 8.40998C17.9932 8.09637 17.7382 7.8414 17.4246 7.68162C17.0681 7.49996 16.6014 7.49996 15.668 7.49996H10.168C9.23455 7.49996 8.76784 7.49996 8.41132 7.68162C8.09771 7.8414 7.84275 8.09637 7.68296 8.40998C7.5013 8.7665 7.5013 9.23321 7.5013 10.1666V15.6666C7.5013 16.6 7.5013 17.0668 7.68296 17.4233C7.84275 17.7369 8.09771 17.9918 8.41132 18.1516C8.76784 18.3333 9.23455 18.3333 10.168 18.3333Z"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6500_6352">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
